import { FC } from 'react';

import { RedeemGiftPage } from '@bpm-web-app/components/src/lib/supreme-account/gifts/redeem';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const AccountGiftRedeemPage: FC<AccountPageProps> = (props) => <RedeemGiftPage {...props} />;

export default AccountGiftRedeemPage;
